import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import MaskedInput from 'react-text-mask'

import Warning from '../../../assets/warning.svg'
import ErrorMessage from '../ErrorMessage/ErrorMessage'

import './Input.css'

const CustomInput = ({ mask, forwardRef, ...props }) =>
  mask ? <MaskedInput mask={mask} {...props}
  /> : <input {...props} ref={forwardRef} />

const Input = ({
  field,
  form,
  label,
  id,
  type,
  inputMode,
  name,
  endAdornment,
  noAdornmentMargin = false,
  className,
  disabled,
  instructions = '',
  ...extraProps
}) => {
  const [focus, setFocus] = useState(false)
  const error = form.errors[field.name] && form.touched[field.name]
  const endAdornmentNode = endAdornment && (
    <span styleName='endAdornment'>{endAdornment}</span>
  )

  return (
    <React.Fragment>
      <div styleName={cx('adornmentWrapper', {
        focus,
        filled: field.value.length,
        error,
        disabled,
        noAdornmentMargin
      })}>
        <div
          data-testid={`${id}-container`}
          className={className}
          styleName='wrapper'
        >
          <label styleName='label' htmlFor={id}>
            {label}
          </label>
          <CustomInput
            onFocus={() => setFocus(true)}
            styleName='input'
            type={type}
            inputMode={inputMode}
            id={id}
            disabled={disabled}
            {...field}
            {...extraProps}
            onBlur={(...e) => {
              field.onBlur(...e)
              setFocus(false)
            }}
          />
        </div>
        {endAdornmentNode || (error && <span styleName='endAdornment'><Warning styleName='warning' /></span>)}
      </div>
      { error
        ? (
          <div data-testid='error-message' styleName='errorMessage'>
            <ErrorMessage name={field.name} />
          </div>
        )
        : (
          <div data-testid='instructions' styleName='instructions'>{instructions}</div>
        )
      }
    </React.Fragment>
  )
}

const FieldShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
})

Input.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  form: PropTypes.object,
  field: FieldShape.isRequired,
  type: PropTypes.string.isRequired,
  endAdornment: PropTypes.node,
  noAdornmentMargin: PropTypes.bool,
  instructions: PropTypes.node
}

export default Input
